var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showBtn)?_c('div',{staticClass:"open-app-button",on:{"click":_vm.handleClick}},[_c('span',[_vm._v("App内打开")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }